import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './PageTitle.module.scss';

const PageTitle = ({ alt, icon, tag, children }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="PageTitle"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <img data-bem="PageTitle__icon" src={icon} alt={alt} className={CN.icon} /> {children}
    </div>
  );
};

export default PageTitle;
